const pagesConfig = {
  howItWorks: 'como-funciona',
  advancedSearch: 'search',
  schoolProfile: 'school',
  login: 'auth/login',
};

export default pagesConfig;
